
import MarkerLogo from "../images/marker.png"

export default function LogEntry({ log }) {
    return (
        <div className="log-container">
            <img src={log.imageUrl} alt="mountain" className="mountain-logo"></img>
            <div className="log-info-container">
                <div className="inline-class">
                    <img src={MarkerLogo} alt="marker" className="marker-logo"></img>
                    <div className="location">{log.location}</div>
                    <a href={log.googleMapsUrl} className="the-link">View on Google Maps</a></div>
                <div className="place">{log.title}</div>
                <div className="date-container">
                    <div className="start-date">{log.startDate}-</div>
                    <div className="end-date">{log.endDate}</div>
                </div>
                <p className="summary">{log.description}</p>
            </div>
        </div>

    )
}